<script lang="ts" setup>
import MPage from "./../MPage";

defineProps(MPage.props);
</script>

<template>
  <m-page class="page-form" v-bind="{ ...$props, ...$attrs }">
    <div class="page-form-content">
      <slot />
    </div>
  </m-page>
</template>

<style lang="scss">
.page-form {
  .page-padding {
    padding: 0;
    min-height: 100%;
    display: flex;
  }

  .page-form-content {
    padding: 16px;
    overflow: hidden;

    background: white;
    flex: 1 1 auto;

    @media screen and (min-width: 800px) {
      max-width: 800px;
      // padding-right: 10px;
    }
  }
}
</style>
